@if (!start) {
  <div class="overlay" [style.height]="isMobileViewport() ? 'calc(100vh - 72px)' : ''">
    <button class="playButton" mat-raised-button (click)="startSchooling()">
      <mat-icon class="playCircleSchooling play_circle_outline">play_circle</mat-icon>
    </button>
  </div>
}
<div class="container">
  @if (!isMobileViewport()) {
    <div class="closeCross">
      <mat-icon (click)="close()" class="cross">close</mat-icon>
    </div>
  }

  <div class="row" [style.display]="isMobileViewport() ? 'none' : ''">
    <section [class]="fold ? 'tableFold' : 'tableUnfold'">
      <mat-card appearance="outlined" class="content">
        <div class="table-container" [fxShow]="dataSource.data.length">
          <table mat-table [dataSource]="dataSource" id="table" class="table" matSort matSortActive="pageNumber" matSortStart="asc"
            [trackBy]="trackById">

            <ng-container matColumnDef="number">
              <th mat-header-cell *matHeaderCellDef>{{ 'number' | translate }}</th>
              <td mat-cell *matCellDef="let index">
                <span [matTooltip]="index.pageNumber">{{ index.pageNumber }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="title">
              <th mat-header-cell *matHeaderCellDef>{{ 'title' | translate }}</th>
              <td mat-cell *matCellDef="let index">
                <span [matTooltip]="index.name">{{ index.name }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef>{{ 'type' | translate }}</th>
              <td mat-cell *matCellDef="let index">
                <mat-icon matTooltip="{{getTypeDescription(index.pageType)}}">{{getTypeIcon(index.pageType)}}</mat-icon>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
            <tr mat-row class="selectable" *matRowDef="let row; columns: tableColumns;"></tr>
          </table>
          <mat-paginator class="mat-paginator-sticky" [pageSize]="10000" [pageSizeOptions]="pageSizeOptions"
          [hidePageSize]="true" [length]="totalCount" [showFirstLastButtons]="true" (page)="pageChange($event)"></mat-paginator>
        </div>
        @if (!dataSource.data.length && !loading) {
          <saf-empty-message (reloadClicked)="reloadTable()"></saf-empty-message>
        }
      </mat-card>
    </section>

    @if (!isMobileViewport()) {
      <div class="foldButton" (click)="foldTable()">
        @if (!fold) {
          <mat-icon>chevron_left</mat-icon>
        }
        @if (fold) {
          <mat-icon>chevron_right</mat-icon>
        }
      </div>
    }

    @if (!isMobileViewport()) {
      <section [class]="fold ? 'viewFold' : 'viewUnfold'">
        <mat-card appearance="outlined" class="contentBox">
          <saf-schooling-index-content [onlineId]="schoolingOnlineId" [indexId]="lastIndexId" [fire]="fire" (result)="showQuestionResult($event)"
          (isContentLoading)="isLoading($event)"></saf-schooling-index-content>
        </mat-card>
      </section>
    }

  </div>

  @if (isMobileViewport()) {
    <div style="display: flex; gap: 8px;">

      @if (!isPortrait) {
        <button class="mobile-button" mat-raised-button (click)="back()" [disabled]="pageNumber <= 1 || contentLoading">
          <mat-icon>keyboard_double_arrow_left</mat-icon>
        </button>
      }

      <mat-card appearance="outlined" class="mobile-schooling" [style]="isPortrait ? 'height: calc(100vh - 130px); margin-bottom: 8px' : ''">
        <saf-schooling-index-content [onlineId]="schoolingOnlineId" [indexId]="lastIndexId" [fire]="fire" (result)="showQuestionResult($event)"
                                     (isContentLoading)="isLoading($event)"></saf-schooling-index-content>
      </mat-card>

      @if (!isPortrait) {
        <button class="mobile-button" mat-raised-button
                [disabled]="executionSeconds !== 0 || contentLoading"
                (click)="pageNumber !== dataSource.data.length ? (pageType !== 1 || questionSuccess ? next() : showResult()) : (pageType !== 1 || quizSuccess ? finish() : showResult())">

          @if (executionSeconds !== 0) {
            <div class="spinnerArea">
              <mat-progress-spinner diameter="25" value="{{progress}}" mode="determinate"></mat-progress-spinner>
              <p>{{executionSeconds}}</p>
            </div>
          } @else {
            @if (pageNumber !== dataSource.data.length) {
              @if (pageType !== 1 || questionSuccess) {
                <mat-icon>keyboard_double_arrow_right</mat-icon>
              } @else {
                <mat-icon>lightbulb</mat-icon>
              }
            } @else {
              @if (pageType !== 1 || quizSuccess) {
                <mat-icon>check</mat-icon>
              } @else {
                <mat-icon>lightbulb</mat-icon>
              }
            }
          }
        </button>
      }

    </div>
  }

  @if (isPortrait || !isMobileViewport()) {
    <div class="buttons">
      <button mat-raised-button (click)="back()" disabled="{{pageNumber <= 1 || contentLoading}}">
        <div class="buttonContent">
          <mat-icon>arrow_back</mat-icon>
          <p>{{ 'back' | translate }}</p>
        </div>
      </button>
      @if (pageNumber !== dataSource.data.length) {
        <button mat-raised-button
                [disabled]="executionSeconds !== 0 || contentLoading"
                (click)="pageType !== 1 || questionSuccess ? next() : showResult()">
          @if (pageType !== 1 || questionSuccess) {
            <div class="buttonContent">
              @if (executionSeconds !== 0) {
                <div class="spinnerArea">
                  <mat-progress-spinner diameter="30" value="{{progress}}" mode="determinate"></mat-progress-spinner>
                  <p>{{ executionSeconds }}</p>
                </div>
              }
              <p>{{ 'next' | translate }}</p>
              <mat-icon>arrow_forward</mat-icon>
            </div>
          }
          @if (pageType === 1 && !questionSuccess) {
            <div class="buttonContent">
              @if (executionSeconds !== 0) {
                <div class="spinnerArea">
                  <mat-progress-spinner diameter="30" value="{{progress}}" mode="determinate"></mat-progress-spinner>
                  <p>{{ executionSeconds }}</p>
                </div>
              }
              <p>{{ 'result' | translate }}</p>
              <mat-icon>lightbulb</mat-icon>
            </div>
          }
        </button>
      }
      @if (pageNumber === dataSource.data.length) {
        <button mat-raised-button
                [disabled]="executionSeconds !== 0 || contentLoading"
                (click)="pageType !== 1 || quizSuccess ? finish() : showResult()">
          @if (pageType !== 1 || quizSuccess) {
            <div class="buttonContent">
              @if (executionSeconds !== 0) {
                <div class="spinnerArea">
                  <mat-progress-spinner diameter="30" value="{{progress}}" mode="determinate"></mat-progress-spinner>
                  <p>{{ executionSeconds }}</p>
                </div>
              }
              <p>{{ 'ready' | translate }}</p>
              <mat-icon>check</mat-icon>
            </div>
          }
          @if (pageType === 1 && !quizSuccess) {
            <div class="buttonContent">
              @if (executionSeconds !== 0) {
                <div class="spinnerArea">
                  <mat-progress-spinner diameter="30" value="{{progress}}" mode="determinate"></mat-progress-spinner>
                  <p>{{ executionSeconds }}</p>
                </div>
              }
              <p>{{ 'result' | translate }}</p>
              <mat-icon>lightbulb</mat-icon>
            </div>
          }
        </button>
      }
    </div>
  }
</div>
